import React from 'react'
import TicketsPriceType from './tickets-price-type'
import IllinoisPriceType from './illinois-price-type'

const shouldShowIllinoisOptions = (showIllinoisOptions, ageGroup) =>
  showIllinoisOptions &&
  ageGroup !== 'infant' &&
  ageGroup !== 'employee' &&
  !ageGroup.includes('constituency')

const isEmployeeType = types => 'employee' in types

const priceKey = employee => (employee ? 'employee' : 'default')

function PriceGroup({
  priceType,
  last,
  illinois,
  showIllinoisOptions,
  hitMaximumsByAge,
  noPrice,
  hidePricingColumn,
  remainingTickets
}) {
  if (shouldShowIllinoisOptions(showIllinoisOptions, priceType.ageGroup)) {
    return (
      <IllinoisPriceType
        priceType={priceType}
        last={last}
        illinois={illinois}
        hitMaximumsByAge={hitMaximumsByAge}
        noPrice={noPrice}
      />
    )
  } else {
    return (
      <TicketsPriceType
        priceType={priceType}
        priceKey={priceKey(isEmployeeType(priceType.types))}
        hitMaximumsByAge={hitMaximumsByAge}
        noPrice={noPrice}
        hidePricingColumn={hidePricingColumn}
        remainingTickets={remainingTickets}
      />
    )
  }
}

export default PriceGroup
